import { RootState } from "@/app/stores"
import {
    CommunitySectionsAvailabilityResponse,
    getCommunitySectionsAvailability,
} from "@/shared/api/community-sections-availability"
import { ErrorType } from "@/shared/types"
import { createAsyncThunk } from "@reduxjs/toolkit"
import { AxiosError } from "axios"

export const fetchCommunitySectionsAvailability = createAsyncThunk<
    CommunitySectionsAvailabilityResponse,
    void,
    { state: RootState }
>("communitySectionsAvailability/fetchCommunitySectionsAvailability", async(_, thunkAPI) => {
    try {
        const data = await getCommunitySectionsAvailability()
        return data.data
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>

        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        })
    }
})
